export default "__VITE_ASSET__VjxjSEm1__"